import { render, staticRenderFns } from "./costAdd.vue?vue&type=template&id=348f2fe8&scoped=true&"
import script from "./costAdd.vue?vue&type=script&lang=js&"
export * from "./costAdd.vue?vue&type=script&lang=js&"
import style0 from "./costAdd.vue?vue&type=style&index=0&id=348f2fe8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348f2fe8",
  null
  
)

export default component.exports